export default "/images/vendor/flag-icon-css/flags/1x1/cl.svg?303f56a616afb6bae962ead1475d28f8";